import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { PopoverComponent } from '../popover.component';

@Injectable({
  providedIn: 'root'
})
export class PopoverService {
  private lastPopover!: PopoverComponent;
  popoversList: Subject<any> = new Subject()
  constructor(private ngZone: NgZone) {
    this.popoversList.subscribe((popover) => {
      this.lastPopover = popover;
    })
  }
  closeLastPopover(event: MouseEvent) {
    this.ngZone.runOutsideAngular(() => { // Running outside Angular's zone
      const target = event.target as HTMLElement;
      if ((target.closest('berry-master')|| target.closest('berry-popup')) && !target.closest('berry-popover')) {
        this.lastPopover?.close()
      }
    });
 

  }

}
